import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _AutoscaleLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M8.77 15 6 12l2.77-3M6 12h12m-2.77 3L18 12l-2.77-3" }),
            React.createElement("path", { stroke: "currentColor", d: "M3 2v20M21 2v20" })));
}
const AutoscaleLightCustom = forwardRef(_AutoscaleLightCustom);
export { AutoscaleLightCustom };
